export var BasePointerKind;
(function (BasePointerKind) {
    BasePointerKind["SINGLE_OBJECT"] = "singleObject";
    BasePointerKind["HTTP"] = "http";
    BasePointerKind["NONE"] = "none";
})(BasePointerKind || (BasePointerKind = {}));
